import{getElementSize as fn}from"../useResizeObserved/getElementSize";export var getElementSize=fn;
//# sourceMappingURL=getElementSize.js.map